package com.fireavert.events.shared.data_models.models

import kotlinx.serialization.Serializable

@Serializable
enum class ReportFrequency(val fileName: String, val displayName: String) {
    DAILY("DailyEmail", "Daily"),
    WEEKLY("WeeklyEmail", "Weekly"),
    MONTHLY("MonthlyEmail", "Monthly"),
    YEARLY("YearlyEmail", "Yearly"),
}